export default {
  /**for qa */
  // version: "4.6.0",
  /**for prod */
  version: "7.2.0"
};
